import Model from '@/models/ExtendModel'

export default class WhSubfamily extends Model {
    resource() {
        return 'wh_subfamily'
    }
}